export default __webpack_public_path__ + "static/media/item-edit.ff1f9384.svg";